module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4Jiyh"))).then(() => parcelRequire('hEqeo'));